@if(error) {
  <div class="alert alert-danger">{{error}}</div>
}

<div class="span9">
  <h1 data-automation-name="systemPropertyIndex">System Properties</h1>
</div>
<p class="lead">
  System properties are core configuration settings. Use with caution as you may remove system properties necessary to Venway's health.
</p>

@if(isAdmin) {
  <div class="span3" style="text-align:right;">
    <a id="createProperty" class="btn btn-large btn-primary" (click)="nextPage($event, '/createSystemProperty', router)" style="margin-top:9px;">Create System Property</a>
  </div>
}

<table class="table table-striped">
  <thead>
  <tr>
    <th>Key</th>
    <th>Value</th>
    <th>Last Modified By</th>
    <th></th>
  </tr>
  </thead>
  <tbody>
    @for(prop of displayedProps; track prop) {
      <tr class="table-active">
        <td>{{prop.key}}</td>
        <td>{{prop.value}}</td>
        <td id="updated_by">{{prop.updated_by}}</td>
        @if(isAdmin) {
          <td>
            <div class="btn-group">
              <a id="edit" class="btn btn-default" (click)="nextPage(prop.key, '/editSystemProperty', router)" name="editProperty">Edit</a>
              <button id="delete" class="btn btn-danger" type="button" (click)="delete(prop)">Delete</button>
            </div>
          </td>
        }
      </tr>
    }
    @if(displayedProps.length === 0) {
      <tr>
        <td colspan="4" style="text-align: center;">No System Properties.</td>
      </tr>
    }
  </tbody>
</table>
